import { cloneElement } from "react";

export const Row = (props: any) => {
  return (
    <div>
      {cloneElement(props.element, {
        style: {
          display: "flex",
          gap: "16px",
          paddingBottom: "32px",
          flexWrap: "wrap",
          lineHeight: 1.5,
        },
      })}
    </div>
  );
};
